import { useTranslation } from 'react-i18next';
import { FaRegTimesCircle } from 'react-icons/fa';

interface ErrorProps {
  msg: string;
}

export function Error({ msg }: ErrorProps) {
  const { t } = useTranslation();

  return (
    <div role="alert" className="alert alert-error alert-soft">
      <FaRegTimesCircle />
      <span>{t(msg)}</span>
    </div>
  );
}
